import { memo } from "react";
import { equals, pick } from "ramda";
import { TertiarySmall } from "@base-ui";
import { Th, Tr, SortableColumn } from "./graphAxisTable.styles";
import { sortDirection } from "utils/sort";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function Headers(_ref) {
  var columns = _ref.columns,
    sort = _ref.sort,
    updateSort = _ref.updateSort;
  var icon = function icon(sort) {
    return {
      none: "listArrows",
      ascending: "sortAsc",
      descending: "sortDesc"
    }[sort];
  };
  var headers = columns.map(function (column) {
    var _column$sortOptions;
    var isActiveSort = (_column$sortOptions = column.sortOptions) === null || _column$sortOptions === void 0 ? void 0 : _column$sortOptions.includes(sort);
    var activeDirection = isActiveSort ? sortDirection(sort) : "none";
    return /*#__PURE__*/_jsx(Th, {
      scope: "col",
      "aria-sort": activeDirection,
      "aria-colindex": "2",
      children: /*#__PURE__*/_jsxs(SortableColumn, {
        onClick: function onClick() {
          return updateSort(column);
        },
        icon: icon(activeDirection),
        active: isActiveSort,
        children: [/*#__PURE__*/_jsx(TertiarySmall, {
          style: {
            margin: 0
          },
          children: column.label
        }), /*#__PURE__*/_jsx("span", {
          className: "hidden-styles",
          children: "Aktivera f\xF6r att sortera kolumnen"
        })]
      })
    }, column.id);
  });
  return /*#__PURE__*/_jsxs(Tr, {
    "aria-rowindex": "1",
    children: [/*#__PURE__*/_jsx(Th, {
      scope: "col",
      "aria-colindex": "1",
      children: /*#__PURE__*/_jsx(TertiarySmall, {
        className: "png-ignore",
        style: {
          margin: "auto",
          textAlign: "center"
        },
        children: "Ta bort"
      })
    }), headers]
  });
}, function (prev, curr) {
  return equals(pick(["columns", "sort"], prev), pick(["columns", "sort"], curr));
});